// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__wDq1e","rotate":"Loader_rotate__NEbL0","path":"Loader_path__Or5Dy","dash":"Loader_dash__BtTPT"};